import React from 'react'
import Layout from '../components/layout'
import {browserHistory} from 'react-router'
import RaisedButton from 'material-ui/RaisedButton';
import PageviewGA from '../components/pageview-ga'

class Body extends React.Component {

    render() {
        return(
            <div className="page-margin layout-column layout-align-center-center">
                <h3 style={{textAlign: "center" }}>You have entered your PIN incorrectly too many times.  Please reset your PIN</h3>
                <br/>
                <RaisedButton style={{minWidth: "280px"}} fullWidth={false} label="RESET PIN" primary={true} onClick={() => browserHistory.push("/reset-pin")}/>
            </div>
        )
    }
}

export default class extends React.Component {

    render() {
        return (
            <div className="layout-row flex">
                <PageviewGA/>
                <Layout title=""
                        showAppBarActions={false}
                        {...this.props}
                        ready={true}
                        body={Body}>
                </Layout>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/pin_lockout.js